module.exports = __webpack_public_path__ + "img/floor_f6_01.077549f2.png";